
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { UserRole } from '@/types/user';
import { ArrowRight } from 'lucide-react';

interface HeroSectionProps {
  previewRole: UserRole;
  setPreviewRole: (role: UserRole) => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ previewRole, setPreviewRole }) => {
  return (
    <section className="relative bg-black py-20 md:py-28 overflow-hidden w-full">
      {/* Background stadium image with 85% black overlay */}
      <div className="absolute inset-0 bg-center bg-cover" 
           style={{backgroundImage: `url('/lovable-uploads/c63819a4-45be-4e74-9e14-09fc268ed40b.png')`}}>
        <div className="absolute inset-0 bg-black opacity-85"></div>
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              <span className="text-sports-green">Where</span><br/>
              <span className="text-white">Communication is</span><br/>
              <span className="text-sports-green">Teamwork</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-300 mb-8">
              The ultimate platform for youth and community sports with multiple account types,
              team management, scheduling and social features.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-sports-green text-black hover:bg-sports-green/90 font-bold">
                <Link to="/register" className="flex items-center">
                  Get Started
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="text-white border-white hover:bg-white hover:text-black font-medium">
                <Link to="/about" className="flex items-center">
                  Learn More
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
            </div>
          </div>
          <div className="md:w-1/2">
            <div className="flex justify-center">
              <img 
                src="/lovable-uploads/9f6bc8b5-d0ab-410b-98a3-b509eb56f617.png" 
                alt="Players Lockeroom Team" 
                className="rounded-lg shadow-xl max-w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
